import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const coreDataForm: Form<Client> = {
  key: 'coreData',
  title: 'Stammdaten',
  fields: [
    {
      key: 'advisor',
      label: 'Fallzuständigkeit',
      fieldTypes: 'text',
    },
    {
      key: 'fileNumber',
      label: 'Aktenzeichen',
      fieldTypes: 'text',
    },
    {
      key: 'caseId',
      label: 'Erfassungsbogen Fall-Nr.',
      fieldTypes: 'text',
    },
    {
      key: 'name',
      label: 'Name der Frau',
      fieldTypes: 'text',
    },
    {
      key: 'phone',
      label: 'Telefon',
      fieldTypes: 'text',
    },
    {
      key: 'address',
      label: 'Anschrift',
      fieldTypes: 'text',
      xsWidth: 12,
    },
    {
      key: 'faxInput',
      label: 'Faxeingang',
      fieldTypes: 'date',
    },
    {
      key: 'incident',
      label: 'Vorfall am',
      fieldTypes: 'date',
    },
    {
      key: 'selfReporter',
      label: 'Selbstmelderin',
      fieldTypes: 'checkbox',
    },
    {
      key: 'repeatCase',
      label: 'Wiederholungsfall',
      fieldTypes: 'checkbox',
    },
    {
      key: 'wayward',
      label: 'Irrläuferin',
      fieldTypes: 'checkbox',
    },
    {
      key: 'domesticViolence',
      label: 'HGW',
      fieldTypes: 'checkbox',
    },
    {
      key: 'exPartnerStalking',
      label: 'Ex-Partner Stalking',
      fieldTypes: 'checkbox',
    },
  ],
};

export default coreDataForm;
